import { ArticleShell } from './ArticleShell';

export function TalkToSomeone() {
    return (
        <ArticleShell>
            <h1 className="mb-10 text-mobile-display-2">
                Hvem kan hjælpe mig?
            </h1>

            <p className="mb-20 text-body">
                Et forløb i en app som denne giver dig konkrete redskaber til at
                forebygge og håndtere stress. Med eller uden app er det dog
                altid godt at få talt med nogen. Det kan være en god ven, et
                hjælpsomt familiemedlem, en lyttende leder eller en støttende
                kollega. For nogle kan det også være relevant at få talt med en
                psykolog.
            </p>

            <p className="mb-20 text-body">
                For mange kræver det mod at række ud til en psykolog. Det kan
                endda føles grænseoverskridende. Der er måske tanker som: "Har
                jeg det dårligt nok?", "Andre har nok mere brug for det end jeg
                har", eller "Det gør mig svag, at jeg vil tale med en psykolog".
            </p>

            <p className="mb-20 text-body">
                Du behøver ikke have det skidt på en bestemt måde, før en
                samtale med en psykolog kan være relevant. Samtidig er det
                vigtigt, at du søger hjælp, hvis du oplever, at belastning
                påvirker din hverdag og arbejdsevne i høj grad.
            </p>

            <p className="mb-20 text-body">
                Det er altid en god idé at tale med egen læge. Særligt hvis
                belastningen er langvarig, eller hvis du overvejer en
                sygemelding. Lægen kan vurdere dine symptomer og udelukke anden
                sygdom.
            </p>

            <p className="mb-20 text-body">
                Næste skridt kan være et samtaleforløb med en psykolog. Her kan
                du få hjælp til at forstå det, du oplever samt redskaber til
                lige netop din situation.
            </p>

            <div className="my-20">
                <img
                    src="/images/articleIllustrations/TalkToSomeoneIllustration1.png"
                    alt="Talk to someone illustration"
                    className="w-full rounded-[10px]"
                />
            </div>

            <h2 className="mb-20 text-mobile-display-1">
                Når livet forandrer sig
            </h2>

            <p className="mb-20 text-body">
                Store livsændringer som skilsmisse, sygdom, tab, arbejdsskifte
                eller det at blive forælder kan vække mange følelser. Nogle
                gange har man brug for hjælp til at finde fodfæste i sin nye
                situation. Det er ikke unormalt at mærke en reaktion, når ens
                livsomstændigheder ændrer sig. Det kan kræve meget energi, og
                man er ikke altid forberedt på det, der kommer. Derfor kan det
                være en hjælp at tale med en, der kan hjælpe med at finde en god
                vej frem igen.
            </p>

            <h2 className="mb-20 text-mobile-display-1">
                Hvis livet ikke ændrer sig nok
            </h2>

            <p className="mb-20 text-body">
                I de situationer, hvor noget er kørt fast, tingene går for
                hurtigt, der er for meget pres og for lidt tid, har vi brug for,
                at noget ændrer sig. Det kan være i de rammer, vi er i, de
                relationer, vi er en del af, og inde i os selv. Her kan det være
                en hjælp at tale med en psykolog, der kan hjælpe dig med at få
                et helikopterperspektiv, så du kan tage stilling til, hvad der
                for dig selv er relevant at ændre på.
            </p>

            <div className="rounded-[10px] bg-dark-red-10p p-20">
                <h2 className="mb-20 text-mobile-display-1">
                    Hvilke symptomer skal jeg holde øje med?
                </h2>

                <p className="mb-20 text-body">
                    Modul 2 handler om stresssymptomer – kroppens signaler på,
                    at noget ikke er helt som det skal være. Du kan bruge
                    modulet til at tjekke ind med, hvordan dine symptomer har
                    udviklet sig, og hvilket niveau de er på. Hvis der er mange
                    symptomer, og de føles voldsomme eller måske altopslugende,
                    kan det være værd at overveje, om forløbet skal suppleres
                    med psykologsamtaler.
                </p>

                <p className="mb-20 text-body">
                    Det kan også være en god indikation, hvis du gennemgående i
                    forløbet oplever, at det er svært at koncentrere dig om
                    øvelserne, ikke synes, at du får noget ud af dem, eller at
                    du bare fornemmer, at det for dig vil være bedst at tale med
                    et andet menneske.
                </p>

                <p className="pb-20 text-body">
                    Du kan undersøge, om du kan få adgang til psykologsamtaler
                    via dit arbejde, dit pensionsselskab, din sundhedsforsikring
                    eller din egen læge.
                </p>
            </div>
        </ArticleShell>
    );
}
